import React from "react";
import moment from "moment";
import localization from "moment/locale/id";

moment.updateLocale("id", localization);
var d = new Date();

export default class LabPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: JSON.parse(localStorage.getItem("puskesmasProfile")),
    };
  }

  titleCase(str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  }

  setAge(d) {
    var age = moment().diff(d, "years", true);
    return Math.floor(age);
  }

  calculateTimeDifference(datetime1, datetime2) {
    const date1 = moment(datetime1, "YYYY-MM-DD hh:mm:ss");
    const date2 = moment(datetime2, "YYYY-MM-DD hh:mm:ss");

    const duration = moment.duration(date2.diff(date1));

    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  render() {
    var Age = this.setAge(this.props.detilPx.patients.birth_date);

    moment.locale("id");
    console.log(this.state.profile.photo);
    return (
      <div style={{ color: "black" }}>
        <table style={{ margin: "24Px", width: "96%" }}>
          <thead>
            <tr style={{ width: "100%" }}>
              <td
                style={{ paddingBottom: "4Px", paddingRight: "90Px" }}
                colSpan="6"
              >
                <img
                  style={{ float: "left", margin: "12Px", width: "66Px" }}
                  alt="Image placeholder"
                  // src={process.env.REACT_APP_LOGO}
                  src={this.state.profile?.photo}
                />
                <center>
                  <h4 style={{ margin: 0, lineHeight: 1 }}>
                    {this.props.profile.report_header_1}
                    <br />
                    {this.props.profile.report_header_2}
                  </h4>
                  <h2 style={{ margin: 0 }}>{this.props.profile.name}</h2>
                  <p
                    className={"text-center"}
                    style={{ paddingLeft: 90, lineHeight: 1, margin: 0 }}
                  >
                    {this.props.profile.address}
                  </p>
                  <p
                    className={"text-center"}
                    style={{ paddingLeft: 90, lineHeight: 1, margin: 0 }}
                  >
                    Telp. {this.props.profile.phone}
                  </p>
                </center>
              </td>
            </tr>
            <tr className={"p-0"}>
              <td colSpan="6">
                <hr style={{ border: "1px solid", margin: 0 }}></hr>
              </td>
            </tr>
          </thead>
          <tbody
            style={{
              width: "100%",
              borderCollapse: "collapse",
              padding: "12Px",
            }}
          >
            <tr style={{ marginTop: 8 }}>
              <td style={{ width: "19%", verticalAlign: "top" }}>
                Nama Pasien
              </td>
              <td style={{ width: "1%", verticalAlign: "top" }}>:</td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                {this.props.detilPx.patients.name}{" "}
                {this.props.detilPx.patients.last_name}
              </td>
              <td
                style={{
                  paddingRight: "40px",
                  verticalAlign: "top",
                  width: "19%",
                }}
              >
                No. MR
              </td>
              <td style={{ width: "1%", verticalAlign: "top" }}>:</td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                {this.props.detilPx.family_folder}-
                {this.props.detilPx.family_relationship_id}
              </td>
            </tr>
            <tr>
              <td style={{ width: "19%", verticalAlign: "top" }}>Alamat</td>
              <td style={{ width: "1%", verticalAlign: "top" }}>:</td>
              <td
                style={{
                  width: "30%",
                  verticalAlign: "top",
                  paddingRight: "22Px",
                }}
              >
                {this.props.detilPx.patients.address},{" "}
                {this.titleCase(this.props.detilPx.villages.name)},{" "}
                {this.titleCase(this.props.detilPx.villages.district.name)},{" "}
                {this.titleCase(
                  this.props.detilPx.villages.district.city.name
                ).replace("Kabupaten ", "Kab. ")}
              </td>
              <td
                style={{
                  paddingRight: "40px",
                  verticalAlign: "top",
                  width: "19%",
                }}
              >
                Jenis Pasien
                <br />
                Pengirim
              </td>
              <td style={{ width: "1%", verticalAlign: "top" }}>
                :<br />:
              </td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                {this.props.detilPx.payment_type_id == 1 ? "UMUM" : "BPJS"}
                <br />
                Poli {this.props.detilPx.clinics.name}
              </td>
            </tr>
            <tr>
              <td style={{ width: "19%", verticalAlign: "top" }}>
                Jenis Kelamin
              </td>
              <td style={{ width: "1%", verticalAlign: "top" }}>:</td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                {this.props.detilPx.patients.sexs.name}
              </td>
              <td
                style={{
                  paddingRight: "40px",
                  width: "19%",
                  verticalAlign: "top",
                }}
              >
                Jenis Sampel
              </td>
              <td style={{ width: "1%", verticalAlign: "top" }}>:</td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                {this.props.samples.join(", ")}
              </td>
            </tr>
            <tr>
              <td style={{ width: "19%", verticalAlign: "top" }}>Tanggal</td>
              <td style={{ width: "1%", verticalAlign: "top" }}>:</td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                {moment(this.props.detilPx.created_at).format("DD-MM-YYYY")}
              </td>
              <td
                style={{
                  paddingRight: "40px",
                  verticalAlign: "top",
                  width: "19%",
                }}
              >
                Sampel diterima
              </td>
              <td style={{ width: "1%", verticalAlign: "top" }}>:</td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                {this.props.registration_lab?.receive_date ?? ""}
              </td>
            </tr>
            <tr>
              <td style={{ width: "19%", verticalAlign: "top" }}>
                Tgl Lahir/Usia
                <br />
              </td>
              <td style={{ width: "1%", verticalAlign: "top" }}>:</td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                {this.props.detilPx.patients.birth_date} / {Age + " th"}
              </td>
              <td style={{ paddingRight: "40px", width: "19%" }}>
                Sampel dianalisis
              </td>
              <td style={{ width: "1%" }}>:</td>
              <td style={{ width: "30%" }}>
                {this.props.registration_lab?.handover_date ?? ""}
              </td>
            </tr>
            <tr>
              <td style={{ width: "19%", verticalAlign: "top" }}></td>
              <td style={{ width: "1%", verticalAlign: "top" }}></td>
              <td style={{ width: "30%", verticalAlign: "top" }}></td>
              <td style={{ paddingRight: "40px", width: "19%" }}>Waktu</td>
              <td style={{ width: "1%" }}>:</td>
              <td style={{ width: "30%" }}>
                {this.props.registration_lab &&
                this.props.registration_lab.receive_date &&
                this.props.registration_lab.handover_date
                  ? this.calculateTimeDifference(
                      this.props.registration_lab.receive_date,
                      this.props.registration_lab.handover_date
                    )
                  : ""}
              </td>
            </tr>
          </tbody>
        </table>
        <table
          style={{ margin: "24Px", width: "96%", borderCollapse: "collapse" }}
        >
          <thead
            style={{
              width: "100%",
              borderCollapse: "collapse",
              padding: "12Px",
            }}
          >
            <tr>
              <th
                style={{
                  width: "25%",
                  border: "1px solid black",
                  padding: "6Px",
                  textAlign: "center",
                }}
              >
                Jenis Pemeriksaan
              </th>
              <th
                style={{
                  width: "10%",
                  border: "1px solid black",
                  padding: "6Px",
                  textAlign: "center",
                }}
              >
                Hasil
              </th>
              <th
                style={{
                  width: "10%",
                  border: "1px solid black",
                  padding: "6Px",
                  textAlign: "center",
                }}
              >
                Satuan
              </th>
              <th
                colSpan={3}
                style={{
                  width: "20%",
                  border: "1px solid black",
                  padding: "6Px",
                  textAlign: "center",
                }}
              >
                Nilai Rujukan
              </th>
              {/* <th style={{ width: '15%', border: '1px solid black', padding: '6Px', textAlign: 'center' }}>
                Metode
              </th>
              <th style={{ width: '20%', border: '1px solid black', padding: '6Px', textAlign: 'center' }}>
                Referensi
              </th> */}
            </tr>
          </thead>
          {this.props.lab.map((x) => {
            let permintaan_ = this.props.labs;
            let hidden = x.details.find(
              (set) =>
                !set.hidden &&
                set.group_id == x.id &&
                permintaan_.some((a) => a.cat == x.id)
            )
              ? true
              : false;
            return (
              <tbody key={x.id}>
                {hidden ? (
                  <tr
                    style={{
                      backgroundColor: "#f2f2f2",
                      border: "1px solid black",
                    }}
                  >
                    <td colSpan="6" style={{ padding: "6Px" }}>
                      {x.name}
                    </td>
                  </tr>
                ) : null}
                {x.details
                  .sort((a, b) => a.order - b.order)
                  .map((f) => {
                    if (f.hidden == false && hidden) {
                      return (
                        <tr style={{ border: "1px solid black" }} key={f.id}>
                          <td
                            style={{
                              padding: "6Px",
                              border: "1px solid black",
                            }}
                          >
                            {f.lab.name}
                          </td>
                          <td
                            style={{
                              padding: "6Px",
                              textAlign: "right",
                              border: "1px solid black",
                            }}
                          >
                            {f.result}
                          </td>
                          <td
                            style={{
                              padding: "6Px",
                              border: "1px solid black",
                            }}
                          >
                            {f.lab.unit}
                          </td>
                          <td
                            colSpan={3}
                            style={{
                              padding: "6Px",
                              border: "1px solid black",
                            }}
                          >
                            {f.lab.normal_value}
                          </td>
                          {/* <td style={{ padding: '6Px', border: '1px solid black'}}></td>
                          <td style={{ padding: '6Px', border: '1px solid black'}}></td> */}
                        </tr>
                      );
                    } else {
                      return null;
                    }
                  })}
              </tbody>
            );
          })}
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td colSpan="2" style={{ padding: "12Px" }}>
                <center>
                  <br></br>Pemeriksa,
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  {this.props.user
                    ? "( " + this.props.user.name + " )"
                    : "........................................"}
                  <br></br>
                  NIP.{" "}
                  {this.props.user
                    ? this.props.user.nip
                    : "....................................."}
                </center>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}
